import React, { useState , forwardRef} from 'react';
import loader from "../assets/svg/candlestick.gif"
import { 
    Modal, 
    Box, 
     } from '@mui/material';
     import Loader from "react-js-loader";
const MyLodder = ({canShow
}) => {
  
  return (
  
      <Modal 
      open={canShow} 
      sx={{ border: 'none' }}>
        <Box
        
        style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '20%',
            height: '8%',

            outline: 'none',
            background: 'transparent',
            p: 4,
            borderRadius: '12px',
            display: 'flex',
            justifyContent: 'center', alignItems: 'center'
        }}
        >
         {/* <Loader type="spinner-cub" bgColor={"#F4D76B"} color={'#F4D76B'} size={50} /> */}
         <img src={loader} height={150} />
        </Box>
      </Modal>
   
   
  );
};
export default MyLodder;
